import React, { useState, useEffect } from "react";
import './UserMenu.css';
import { NavLink, useNavigate, useLocation } from "react-router-dom";
import { Menu, MenuItem, Button } from '@mui/material';

const UserMenu = () => {
  const [selectedOption, setSelectedOption] = useState('');
  const [anchorEl, setAnchorEl] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();

  const handleOptionSelect = (option, path, event) => {
    event.preventDefault();
    setSelectedOption(option);
    navigate(path);
    setAnchorEl(null); // Close the dropdown
  };

  const getButtonLabel = () => {
    return `My Account (${selectedOption || "Select"})`;
  };

  useEffect(() => {
    const currentPath = location.pathname;

    if (currentPath.includes("/dashboard/user/profile")) {
      setSelectedOption("Profile");
    } else if (currentPath.includes("/dashboard/user/orderhistory")) {
      setSelectedOption("Orders History");
    } else if (currentPath.includes("/dashboard/user/wishlist")) {
      setSelectedOption("Wishlist");
    } else {
      setSelectedOption("Select");
    }
  }, [location.pathname]);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      {/* Large screens */}
      <div className="myAccountBox d-none d-lg-block">
        <h1 className="dashLeftTitle">My Account</h1>
        <div className="list-group list-group-flush">
          <NavLink
            to="/dashboard/user/profile"
            className={`list-group-itemum list-group-item list-group-item-action ${selectedOption === 'Profile' ? 'active' : ''}`}
            onClick={() => setSelectedOption('Profile')}
          >
            Profile
          </NavLink>
          <NavLink
            to="/dashboard/user/orderhistory"
            className={`list-group-itemum list-group-item list-group-item-action ${selectedOption === 'Orders History' ? 'active' : ''}`}
            onClick={() => setSelectedOption('Orders History')}
          >
            Orders History
          </NavLink>
          <NavLink
            to="/dashboard/user/wishlist"
            className={`list-group-itemum list-group-item list-group-item-action ${selectedOption === 'Wishlist' ? 'active' : ''}`}
            onClick={() => setSelectedOption('Wishlist')}
          >
            Wishlist
          </NavLink>
        </div>
      </div>

      {/* Small screens */}
      <div className="userMenubtnClass d-lg-none">
        <Button
          className="btn-secondary dropdown-toggle drpUserbtnMyAct"
          aria-controls={anchorEl ? 'dropdown-menu' : undefined}
          aria-haspopup="true"
          onClick={handleClick}
        >
          {getButtonLabel()}
        </Button>

        <Menu
          id="dropdown-menu"
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleClose}
          className="full-width-menu"
        >
          <MenuItem
            component={NavLink}
            to="/dashboard/user/profile"
            selected={selectedOption === 'Profile'}
            onClick={(event) => handleOptionSelect("Profile", "/dashboard/user/profile", event)}
          >
            <span className="dott"></span> Profile
          </MenuItem>
          <MenuItem
            component={NavLink}
            to="/dashboard/user/orderhistory"
            selected={selectedOption === 'Orders History'}
            onClick={(event) => handleOptionSelect("Orders History", "/dashboard/user/orderhistory", event)}
          >
            <span className="dott"></span> Orders History
          </MenuItem>
          <MenuItem
            component={NavLink}
            to="/dashboard/user/wishlist"
            selected={selectedOption === 'Wishlist'}
            onClick={(event) => handleOptionSelect("Wishlist", "/dashboard/user/wishlist", event)}
          >
            <span className="dott"></span> Wishlist
          </MenuItem>
        </Menu>
      </div>
    </>
  );
};

export default UserMenu;
